module.exports = __webpack_public_path__ + "img/whatsapp-header.b9c75ef1.svg";